/**
 * PetVibe brand chips
 * - Chips link to native ?filter.p.vendor=VENDOR (works once Search & Discovery
 *   has Vendor enabled).
 * - Hide chips with 0 products in this collection (products.json vendor counts,
 *   case-insensitive). "Alle merken" always stays.
 * - Fallback: load collection products.json (all pages) and filter client-side
 *   by product.vendor, then rebuild the product grid.
 */
(function () {
  const PARAM = 'filter.p.vendor';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function getVendorFromUrl() {
    try {
      return new URL(window.location.href).searchParams.get(PARAM) || '';
    } catch (e) {
      return '';
    }
  }

  function normVendor(v) {
    return String(v || '')
      .trim()
      .toLowerCase();
  }

  function money(amount, format) {
    const n = Number(amount);
    if (!Number.isFinite(n)) return String(amount || '');
    const formatted = n.toLocaleString('nl-BE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    if (!format) return '€' + formatted;
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(n)))
      .replace(/\{\{\s*amount\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, formatted);
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(s) {
    return escapeHtml(s).replace(/'/g, '&#39;');
  }

  function setActiveChips(root, vendor) {
    const want = normVendor(vendor);
    root.querySelectorAll('[data-pv-brand]').forEach((el) => {
      if (el.hidden) return;
      const v = el.getAttribute('data-pv-brand') || '';
      const active = want
        ? normVendor(v) === want
        : el.hasAttribute('data-pv-brand-all');
      el.classList.toggle('is-active', active);
      if (active) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
    });
  }

  function pageVendorsFromMeta() {
    try {
      if (typeof meta !== 'undefined' && meta.products && meta.products.length) {
        return meta.products.map((p) => p.vendor);
      }
    } catch (e) {}
    return null;
  }

  function nativeFilterLooksActive(vendor) {
    if (!vendor) return true;
    // Native vendor filter only counts when Search & Discovery renders a
    // filter.p.vendor facet input that is checked. Otherwise Shopify ignores the
    // URL param (page 1 can then look filtered by chance, page 2+ is not).
    const want = normVendor(vendor);
    const inputs = document.querySelectorAll('input[name="' + PARAM + '"]:checked');
    return Array.from(inputs).some((el) => normVendor(el.value) === want);
  }

  function updateCounts(n) {
    const label = n + (n === 1 ? ' artikel' : ' artikelen');
    document
      .querySelectorAll('.products-count-wrapper [role="status"]')
      .forEach((el) => (el.textContent = label));
    document
      .querySelectorAll('.facets__see-results')
      .forEach((el) => (el.textContent = label + ' bekijken'));
    document
      .querySelectorAll('link[rel="next"], link[rel="prev"]')
      .forEach((el) => el.remove());
  }

  async function fetchCollectionProducts(handle) {
    const products = [];
    let page = 1;
    while (page <= 20) {
      const url =
        '/collections/' +
        encodeURIComponent(handle) +
        '/products.json?limit=250&page=' +
        page;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) break;
      const data = await res.json();
      const batch = data.products || [];
      products.push(...batch);
      if (batch.length < 250) break;
      page += 1;
    }
    return products;
  }

  function vendorCounts(products) {
    const counts = Object.create(null);
    products.forEach((p) => {
      const key = normVendor(p.vendor);
      if (!key) return;
      counts[key] = (counts[key] || 0) + 1;
    });
    return counts;
  }

  /** Hide brand chips with 0 products in this collection. Keep "Alle merken". */
  function hideEmptyChips(root, counts) {
    root.querySelectorAll('[data-pv-brand]').forEach((el) => {
      if (el.hasAttribute('data-pv-brand-all')) {
        el.hidden = false;
        return;
      }
      const key = normVendor(el.getAttribute('data-pv-brand'));
      const n = key ? counts[key] || 0 : 0;
      el.hidden = n < 1;
      if (n < 1) {
        el.classList.remove('is-active');
        el.removeAttribute('aria-current');
      }
    });
  }

  function ensureFallbackStyles() {
    if (document.getElementById('pv-brand-fallback-style')) return;
    const style = document.createElement('style');
    style.id = 'pv-brand-fallback-style';
    style.textContent = `
      .pv-brand-fallback__card{display:flex;flex-direction:column;gap:.5rem;height:100%}
      .pv-brand-fallback__media{position:relative;display:block;aspect-ratio:1/1;overflow:hidden;background:#f5f5f5}
      .pv-brand-fallback__media img{width:100%;height:100%;object-fit:cover;display:block}
      .pv-brand-fallback__badge{position:absolute;left:.5rem;top:.5rem;background:#111;color:#fff;font-size:.75rem;padding:.2rem .45rem;border-radius:4px}
      .pv-brand-fallback__title{color:inherit;text-decoration:none;font-size:.95rem;line-height:1.35}
      .pv-brand-fallback__price{font-size:.95rem;font-weight:600}
      .pv-brand-fallback__empty{grid-column:1/-1;padding:2rem 0;text-align:center;opacity:.75}
    `;
    document.head.appendChild(style);
  }

  function cardHtml(product, moneyFormat) {
    const variant = (product.variants && product.variants[0]) || {};
    const img =
      (product.images && product.images[0] && product.images[0].src) || '';
    const href = '/products/' + product.handle + (variant.id ? '?variant=' + variant.id : '');
    const price = money(variant.price, moneyFormat);
    const soldOut = variant.available
      ? ''
      : '<span class="pv-brand-fallback__badge">Uitverkocht</span>';
    return (
      '<li class="product-grid__item pv-brand-fallback__item" data-product-id="' +
      product.id +
      '" data-pv-vendor="' +
      escapeAttr(product.vendor || '') +
      '">' +
      '<article class="pv-brand-fallback__card">' +
      '<a class="pv-brand-fallback__media" href="' +
      href +
      '">' +
      (img
        ? '<img src="' +
          escapeAttr(img) +
          '" alt="' +
          escapeAttr(product.title) +
          '" loading="lazy" width="600" height="600">'
        : '') +
      soldOut +
      '</a>' +
      '<div class="pv-brand-fallback__info">' +
      '<a class="pv-brand-fallback__title" href="' +
      href +
      '">' +
      escapeHtml(product.title) +
      '</a>' +
      '<div class="pv-brand-fallback__price">' +
      escapeHtml(price) +
      '</div></div></article></li>'
    );
  }

  /* AUTO MODE (section without brand blocks): chips from published vendors. */
  function prettyVendor(v) {
    const s = String(v || '').trim();
    if (s !== s.toUpperCase()) return s;
    return s
      .toLowerCase()
      .split(' ')
      .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
      .join(' ');
  }

  /** Returns false when the bar was removed (<2 brands). */
  function buildAutoChips(root, products) {
    const originals = Object.create(null);
    products.forEach((p) => {
      const v = String(p.vendor || '').trim();
      const key = normVendor(v);
      if (key && !originals[key]) originals[key] = v;
    });
    const vendors = Object.keys(originals)
      .map((k) => originals[k])
      .sort((a, b) => a.localeCompare(b, 'nl', { sensitivity: 'base' }));

    /* 2026-11-01: uitzondering hondenkussens (1 merk) */
    const minBrands = root.getAttribute('data-collection-handle') === 'hondenkussens' ? 1 : 2;
    if (vendors.length < minBrands) {
      root.remove();
      return false;
    }

    const row = root.querySelector('.pv-brand-chips__row');
    const current = Array.from(
      row.querySelectorAll('[data-pv-brand]:not([data-pv-brand-all])')
    ).map((el) => normVendor(el.getAttribute('data-pv-brand')));
    const same =
      current.length === vendors.length &&
      current.every((v, i) => v === normVendor(vendors[i]));

    if (!same) {
      row
        .querySelectorAll('[data-pv-brand]:not([data-pv-brand-all])')
        .forEach((el) => el.remove());
      const base = root.getAttribute('data-collection-url') || window.location.pathname;
      let sort = '';
      try {
        sort = new URL(window.location.href).searchParams.get('sort_by') || '';
      } catch (e) {}
      vendors.forEach((v) => {
        const a = document.createElement('a');
        a.setAttribute('role', 'listitem');
        a.className = 'pv-brand-chips__chip';
        a.href =
          base +
          '?' +
          PARAM +
          '=' +
          encodeURIComponent(v) +
          (sort ? '&sort_by=' + encodeURIComponent(sort) : '');
        a.setAttribute('data-pv-brand', v);
        a.textContent = prettyVendor(v);
        row.appendChild(a);
      });
    }
    root.hidden = false;
    return true;
  }

  async function rebuildGrid(root, vendor, allProducts) {
    const moneyFormat = root.getAttribute('data-money-format') || '';
    const grid =
      document.querySelector('ul.product-grid[data-testid="product-grid"]') ||
      document.querySelector('ul.product-grid');
    if (!grid) return;

    ensureFallbackStyles();
    const resultsList = document.querySelector('results-list');
    if (resultsList) resultsList.setAttribute('infinite-scroll', 'false');
    grid.setAttribute('data-last-page', '1');
    if (resultsList) {
      resultsList
        .querySelectorAll('[ref="viewMoreNext"], [ref="viewMorePrevious"]')
        .forEach((el) => el.remove());
    }

    const want = normVendor(vendor);
    const products = (allProducts || []).filter(
      (p) => normVendor(p.vendor) === want
    );
    updateCounts(products.length);
    if (!products.length) {
      grid.innerHTML =
        '<li class="pv-brand-fallback__empty">Geen producten voor dit merk in deze collectie.</li>';
      return;
    }
    grid.innerHTML = products.map((p) => cardHtml(p, moneyFormat)).join('');
    // Horizon infinite scroll can still append/prepend unfiltered pages
    // (e.g. when the URL has ?page=2). Keep only our filtered cards.
    new MutationObserver(function () {
      grid
        .querySelectorAll(':scope > li:not(.pv-brand-fallback__item)')
        .forEach((el) => el.remove());
    }).observe(grid, { childList: true });
  }

  ready(function () {
    const root = document.querySelector('[data-pv-brand-chips]');
    if (!root) return;

    const vendor = getVendorFromUrl();
    // All products of a brand are shown on one page; a ?page=N with a brand
    // filter would load unfiltered server pages. Drop the page param.
    if (vendor && !nativeFilterLooksActive(vendor)) {
      try {
        const u = new URL(window.location.href);
        if (u.searchParams.has('page')) {
          u.searchParams.delete('page');
          window.location.replace(u.toString());
          return;
        }
      } catch (e) {}
    }
    setActiveChips(root, vendor);

    const handle = root.getAttribute('data-collection-handle');
    if (!handle) return;

    fetchCollectionProducts(handle)
      .then(function (all) {
        if (root.hasAttribute('data-pv-auto') && !buildAutoChips(root, all)) return;
        const counts = vendorCounts(all);
        hideEmptyChips(root, counts);
        setActiveChips(root, vendor);

        if (vendor && !nativeFilterLooksActive(vendor)) {
          return rebuildGrid(root, vendor, all);
        }
      })
      .catch(function (err) {
        console.warn('[pv-brand-chips] failed', err);
        if (vendor && !nativeFilterLooksActive(vendor)) {
          rebuildGrid(root, vendor, []).catch(function () {});
        }
      });
  });
})();
